import { Component } from '@angular/core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalEmprestimoComponent } from 'src/app/shared/modals/modal-emprestimo/modal-emprestimo.component';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
@Component({ selector: 'app-meus-emprestimos', templateUrl: './meus-emprestimos.component.html', styleUrls: ['./meus-emprestimos.component.css'] })
export class MeusEmprestimosComponent {
  tamanhoLista!: number;
  myRequestsFilter: any = { itemsPerPage: 5, page: 1 };
  //icones
  faEye = faEye;
  loading: boolean = false;
  myRequests: any;
  constructor(private socialSecurityService: SocialSecurityService, private modalService: NgbModal) {
    this.getFilter();
  }
  getFilter() {
    this.loading = true;
    this.socialSecurityService.listLoans({ itemsPerPage: this.myRequestsFilter.itemsPerPage, page: this.myRequestsFilter.page }).subscribe((res: any) => {
      this.myRequests = res.items;
      this.tamanhoLista = res.totalFiltered;
      this.loading = false;
    });
  }
  onChangePagination(page: number) {
    this.myRequestsFilter.page = page;
    this.getFilter();
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.myRequestsFilter.itemsPerPage = quantidade;
    this.myRequestsFilter.page = 1;
    this.getFilter();
  }
  visualizarEmprestimo(emprestimo: any) {
    const modalRef = this.modalService.open(ModalEmprestimoComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.emprestimo = emprestimo;
  }
}
